import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

// Import components
import errors from './modules/errors'
import management from './modules/management'
import shared from './modules/shared'
import core from './modules/core'
import fm from './modules/fm'
import fmmodule from './modules/fmmodule'

Vue.use(Vuex)

let debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    'errors' : errors,
    'management': management,
    'shared': shared,
    'core': core,
    'fm': fm,
    'fmmodule': fmmodule
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
